import { isIOS } from 'react-device-detect';

export const linkTarget = isIOS ? '_self' : '_blank';
export const os = isIOS ? 'iOS' : 'Android';

export const appSelector = (androidUrl, IosUrl) => {
  return isIOS ? IosUrl : androidUrl;
};
